// import { api } from "../../services/authenticationApi";
import {api} from "../../services/api";

// filterConfig.js
export const FILTER_CONFIG = {
    gender: {
      key: 'gender',
      apiKey: 'gender',
      label: 'Gender',
      type: 'checkbox',
      options: ['Man', 'Woman'],
      defaultValue: []
    },
    ageRange: {
      key: 'ageRange',
      apiKey: 'age_range',
      label: 'Age Range',
      type: 'checkbox',
      options: ['18-24', '25-34', '35-44', '45-54', '55-64', '65+'],
      defaultValue: [],
      order: ['18-24', '25-34', '35-44', '45-54', '55-64', '65+']
    },
    employmentStatus: {
      key: 'employmentStatus',
      apiKey: 'employment_status',
      label: 'Employment Status',
      type: 'checkbox',
      options: ['Independent', 'Part-time', 'Full-time', 'Unemployed'],
      defaultValue: []
    },
    income: {
      key: 'income',
      apiKey: 'income',
      label: 'Income',
      type: 'checkbox',
      options: ['<10000', '10000-19999', '20000-29999', '30000-39999', '40000-49999', '50000-99999', '100000-199999', '>200000'],
      defaultValue: [],
      order: ['<10000', '10000-19999', '20000-29999', '30000-39999', '40000-49999', '50000-99999', '100000-199999', '>200000']
    },
    education: {
      key: 'education',
      apiKey: 'education',
      label: 'Education',
      type: 'checkbox',
      options: ['Elementary', 'Low High school', 'MBO/ High school', 'HBO/WO Bachelor', 'Master or PHD'],
      defaultValue: [],
      order: ['Elementary', 'Low High school', 'MBO/ High school', 'HBO/WO Bachelor', 'Master or PHD']
    },
    householdSituation: {
      key: 'householdSituation',
      apiKey: 'household_situation',
      label: 'Household Situation',
      type: 'checkbox',
      options: [
        'Kids living at home',
        'Living alone',
        'Living together without kids unmarried',
        'Living together married without kids',
        'Living together with kids unmarried',
        'Living together married with kids',
        'Parent living alone',
        'Other',
        'Person in institutional housing'
      ],
      defaultValue: []
    },
    maritalStatus: {
      key: 'maritalStatus',
      apiKey: 'marital_status',
      label: 'Marital',
      type: 'checkbox',
      options: ['Unmarried', 'Married', 'Widowed', 'Divorced'],
      defaultValue: []
    }
  };
  
  // Helper functions
  export const getFilterKeys = () => Object.keys(FILTER_CONFIG);
  
  export const getFilterByKey = (key) => FILTER_CONFIG[key];
  
  export const getFilterByApiKey = (apiKey) => 
    Object.values(FILTER_CONFIG).find(filter => filter.apiKey === apiKey);
  
  export const createInitialFilters = async (userData, maxPersonas) => {
    const filters = {
      numberOfPersonas: userData.personaFilters?.numberOfPersonas || Math.min(20, maxPersonas)
    };

    let prevResearch = null;
    if (userData.userID && userData.researchID) {
      try {
        prevResearch = await api.getPreviousResearch(userData.userID, userData.researchID);
      } catch (error) {
        console.error('Failed to load previous research:', error);
        // Continue with userData.generatedPersonaFilters fallback
      }
    }

    Object.values(FILTER_CONFIG).forEach(filter => {
      let filterValue = filter.defaultValue;
      
      // First check generatedPersonaFilters for initial values (if they exist)
      // First we pull the value from generatedPersonaFilters from the original server

      if (prevResearch.generatedPersonaFilters?.[filter.apiKey]) {
        const generatedValue = prevResearch.generatedPersonaFilters[filter.apiKey];

        // Validate that the generated filter values are valid options, as it's an LLM response
        if (Array.isArray(generatedValue)) {
          const validValues = generatedValue.filter(value => 
            filter.options.includes(value)
          );
          if (validValues.length > 0) {
            filterValue = validValues;
          }
        } else if (filter.options.includes(generatedValue)) {
          filterValue = [generatedValue];
        }
      }
      
      // user-defined personaFilters take priority if they differ from default or the generated values
      if (filterValue === filter.defaultValue && userData.personaFilters?.[filter.apiKey]) {
        const userValue = userData.personaFilters[filter.apiKey];
        filterValue = Array.isArray(userValue) 
          ? userValue 
          : (userValue ? [userValue] : filter.defaultValue);
      }
      
      filters[filter.key] = filterValue;
    });

    return filters;
  };
  
  export const createEmptyFilters = (numberOfPersonas = 5) => {
    const filters = { numberOfPersonas };
    
    Object.values(FILTER_CONFIG).forEach(filter => {
      filters[filter.key] = filter.defaultValue;
    });
  
    return filters;
  };
  
  export const convertFiltersToApiFormat = (filters) => {
    const apiFilters = {
      numberOfPersonas: filters.numberOfPersonas
    };
  
    Object.values(FILTER_CONFIG).forEach(filter => {
      apiFilters[filter.apiKey] = filters[filter.key];
    });
  
    return apiFilters;
  };
  
  export const formatAttributeLabel = (attr) =>
    attr
      .replace(/_/g, ' ') 
      .replace(/\b\w/g, char => char.toUpperCase());
  
  export const sortByOrder = (data, order) => {
    if (!order) return data;
    return [...data].sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name));
  };
  